export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="24" cy="24" r="22" stroke="#D4A359" strokeWidth="1.5" strokeDasharray="4 2" />
    <path d="M16 32V16H20L28 26V16H32V32H28L20 22V32H16Z" fill="#F5F5F0" />
    <path d="M14 34L18 34" stroke="#D4A359" strokeWidth="2" strokeLinecap="round" />
    <circle cx="34" cy="14" r="3" fill="#F59E0B" style={{ filter: "drop-shadow(0 0 6px #F59E0B)" }} />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark className={compact ? "w-8 h-8" : "w-9 h-9"} />
    <span className="text-lg tracking-tight text-[#FBF9F5] font-sans font-semibold">
      LM<span className="text-amber-400 font-serif italic font-medium">service</span>event
    </span>
  </div>
);
